import { h } from "preact";

function SlideInfo ({ title, description, advantages }: any) {
  return (
    <div className="index__wrapper-slider-slide-block-container">
      <div className="index__wrapper-slider-slide-block-title title1">
        {title}
      </div>
      <div className="index__wrapper-slider-slide-block-desc text1">
        <p>
          {description}
        </p>
      </div>
      {advantages && advantages.length > 0 && 
      <div className="index__wrapper-slider-slide-block-items">
        {advantages.map((advantage)=> <div className="index__wrapper-slider-slide-block-items-item">
          {advantage}
        </div>)}
      </div>
      }
      
    </div>
  );
}

export { SlideInfo };
